import React from 'react';
import moment from 'moment';

export default function Footer() {
    return (
        <div>
            <div className="alignCenter footerNote">Poftigo © {moment().format('YYYY')}</div>
        </div>
    )
}